import * as Sentry from "@sentry/browser"

import { useAxiosClient } from "../AxiosClient"
import { paymentApiUrl } from "../Config"
import { useAppDispatch } from "../State"
import { NetgiroState, NetgiroStateI } from "./NetgiroState"
interface NetgiroSignatureResponse {
  cartId: string
  applicationId: string
  totalAmount: number
  referenceNumber: string
  signature: string
}

export const useNetgiroPaymentApi = () => {
  const dispatch = useAppDispatch()
  const axios = useAxiosClient()

  return {
    signRequest: async ({
      cartId
    }: {
      cartId: string
    }): Promise<NetgiroStateI> => {
      try {
        const response = await axios.post<NetgiroSignatureResponse>(
          paymentApiUrl("/netgiro/sign"),
          {
            cartId
          }
        )
        return dispatch(
          NetgiroState.actions.setPaymentState({
            signature: response.data.signature,
            totalAmount: response.data.totalAmount,
            referenceNumber: response.data.referenceNumber,
            applicationId: response.data.applicationId
          })
        ).payload
      } catch (error) {
        Sentry.captureException(error)
        throw error
      }
    }
  }
}
